(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /* Navigation drawer open/close */
  class MojiDrawer {
    constructor() {
      this.drawer = document.getElementById('MojiNavDrawer');
      if (!this.drawer) return;
      this.overlay = document.querySelector('[data-moji-drawer-overlay]');
      this.openers = document.querySelectorAll('[data-moji-drawer-open]');
      this.lastFocus = null;

      this.openers.forEach((btn) => btn.addEventListener('click', () => this.open(btn)));
      this.drawer.querySelectorAll('[data-moji-drawer-close]').forEach((btn) =>
        btn.addEventListener('click', () => this.close())
      );
      if (this.overlay) this.overlay.addEventListener('click', () => this.close());
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.drawer.classList.contains('is-open')) this.close();
      });
    }

    open(opener) {
      this.lastFocus = opener || document.activeElement;
      this.drawer.hidden = false;
      if (this.overlay) this.overlay.hidden = false;
      requestAnimationFrame(() => {
        this.drawer.classList.add('is-open');
        if (this.overlay) this.overlay.classList.add('is-open');
      });
      this.openers.forEach((b) => b.setAttribute('aria-expanded', 'true'));
      /* transparent drawer — keep the page scrollable behind it */
      this.drawer.focus();
    }

    close() {
      this.drawer.classList.remove('is-open');
      if (this.overlay) this.overlay.classList.remove('is-open');
      this.openers.forEach((b) => b.setAttribute('aria-expanded', 'false'));
      document.body.style.overflow = '';
      const onEnd = () => {
        this.drawer.hidden = true;
        if (this.overlay) this.overlay.hidden = true;
        this.drawer.removeEventListener('transitionend', onEnd);
      };
      this.drawer.addEventListener('transitionend', onEnd);
      if (this.lastFocus) this.lastFocus.focus();
    }
  }
  document.addEventListener('DOMContentLoaded', () => new MojiDrawer());

  /* Sticky header (kept from Dawn, trimmed for the minimal markup) */
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
